var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flash-message',{staticClass:"flashpool",attrs:{"transition-name":"flash"}})}
var staticRenderFns = []

export { render, staticRenderFns }